import { gsap } from 'gsap';

const selectors = {
  closeButton: '[data-close-button]',
  content: '[data-content]',
  overlay: '[data-overlay]',
}

class EmailPopup extends HTMLElement {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
    this.animateIn = this.animateIn.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  animateIn() {
    const timeline = gsap.timeline();
    timeline.from(this.content, {
      autoAlpha: 0,
      scale: 0.95,
      duration: 0.85,
      ease: 'elastic.out(1, 0.95)',
      delay: 0.2,
    })
    timeline.from(this.overlay, {
      autoAlpha: 0,
      duration: 0.5,
      ease: 'power2.inOut',
      delay: 0.15,
    }, 0)
  }

  handleClose() {
    this.classList.remove('email-popup--visible');
    const timeline = gsap.timeline();
    timeline.to(this.content, {
      autoAlpha: 0,
      scale: 0.95,
      duration: 0.85,
      ease: 'elastic.out(1, 0.95)',
      delay: 0.2,
    })
    timeline.to(this.overlay, {
      autoAlpha: 0,
      duration: 0.5,
      ease: 'power2.inOut',
      delay: 0.15,
    }, 0)
    timeline.call(() => {
      this.remove();
      document.documentElement.classList.remove('overflow-hidden');
      localStorage.setItem('email-popup-closed', 'true');
    })
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.handleClose();
    }
  }

  connectedCallback() {
    this.closeButton = this.querySelector(selectors.closeButton);
    this.content = this.querySelector(selectors.content);
    this.overlay = this.querySelector(selectors.overlay);
    
    this.hasClosed = localStorage.getItem('email-popup-closed');
    
    if (this.hasClosed) {
      this.remove();
      return;
    }
    
    this.removeAttribute('inert');
    this.classList.add('email-popup--visible');
    document.documentElement.classList.add('overflow-hidden');
    
    this.closeButton?.addEventListener('click', this.handleClick);
    this.overlay?.addEventListener('click', this.handleClick);
    window.addEventListener('keydown', this.handleKeydown, { passive: true });
    this.animateIn();
  }

  disconnectedCallback() {
    this.closeButton?.removeEventListener('click', this.handleClick);
    this.overlay?.removeEventListener('click', this.handleClick);
    window.removeEventListener('keydown', this.handleKeydown, { passive: true });
  }

  handleClick(event) {
    event.preventDefault();
    this.handleClose();
  }
}

if (!customElements.get('email-popup')) {
  customElements.define('email-popup', EmailPopup);
}